import { MessageSquareText, Phone } from "lucide-react";
import { BUSINESS, smsHref } from "../data/site";

export const TextPhotoButton = ({ service, dark = false, compact = false, testid = "cta-text-photo", className = "" }) => (
  <a
    href={smsHref(service)}
    data-testid={testid}
    className={`btn-cut inline-flex items-center justify-center gap-2 font-semibold transition-colors duration-200 ${
      compact ? "px-2.5 sm:px-3 py-2 text-xs sm:text-sm" : "px-6 py-3.5 text-base"
    } ${dark ? "bg-rust text-cream hover:bg-rust-dark" : "bg-rust text-cream hover:bg-rust-dark"} ${className}`}
  >
    <MessageSquareText size={compact ? 16 : 19} strokeWidth={2.2} aria-hidden />
    <span>{compact ? "Text" : "Text a Photo — Fast Quote"}</span>
  </a>
);

export const CallButton = ({ dark = false, compact = false, testid = "cta-call", className = "" }) => (
  <a
    href={BUSINESS.phoneHref}
    data-testid={testid}
    className={`btn-cut inline-flex items-center justify-center gap-2 font-semibold transition-colors duration-200 ${
      compact ? "px-2.5 sm:px-3 py-2 text-xs sm:text-sm" : "px-6 py-3.5 text-base"
    } ${
      dark
        ? "bg-transparent text-cream border-2 border-cream/40 hover:border-cream hover:text-white"
        : "bg-charcoal text-cream hover:bg-coal"
    } ${className}`}
  >
    <Phone size={compact ? 16 : 19} strokeWidth={2.2} aria-hidden />
    <span>{compact ? "Call" : `Call ${BUSINESS.phoneDisplay}`}</span>
  </a>
);

export const CTAPair = ({ service, dark = false, compact = false, testidPrefix = "cta" }) => (
  <div className="flex flex-wrap items-center gap-3" data-testid={`${testidPrefix}-pair`}>
    <TextPhotoButton service={service} dark={dark} compact={compact} testid={`${testidPrefix}-text`} />
    <CallButton dark={dark} compact={compact} testid={`${testidPrefix}-call`} />
  </div>
);
